import React, { Component } from 'react';

import API from '../../../../utils/API';
import SelectField from '../../../../components/inputs/selectField';
import InputField from '../../../../components/inputs/inputField';

import FieldModal from '../../../../components/modals/fieldModal';


class AddPointsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			availablePoints: [],
			availablePointOptions: [],
			selectedValue: { label: '', color: '#00B8D9' },
			referenceId: '',
			referenceModel: null,
			modelOptions: [],
			submitting: false,
			invalid: false,
			error: '',
			requiredFields: {
				selectedValue: false,
				referenceId: false
			}
		};
	}

	componentWillMount() {
		const { orgId, eventId } = this.props;
		this.setState({ loading: true });
		API().get(`Organizations/${orgId}/events/${eventId}/interactions`).then((res) => {
			if (res.data) {
				this.setState({
					availablePoints: res.data.points,
					availablePointOptions: res.data.points.map((p) => {
						return {
							label: `${p.customLabel ? p.customLabel : p.actionName} (${p.pointValue})`,
							value: p._id,
							actionName: p.actionName
						};
					}).sort((a, b) => a.label.localeCompare(b.label)),
					loading: false
				});
			}
		});
	}

	handlePointsChosen = async (e) => {
		const { orgId, eventId } = this.props;
		const { availablePoints } = this.state;
		const selectedPoint = availablePoints.length > 0 && availablePoints.find((p) => p._id == e.value);

		let modelOptions = [];
		let referenceModel = null;

		if (selectedPoint && selectedPoint.referenceModel) {
			referenceModel = selectedPoint.referenceModel;
			switch (referenceModel) {
				case 'Session':
					modelOptions = (this.props.sessions || []).map((s) => ({
						label: s.name,
						value: s._id
					}));
					break;
				case 'Survey':
					modelOptions = (this.props.sessions || [])
						.filter((s) => s.surveyId)
						.map((s) => ({ label: s.name, value: s.surveyId }));
					break;
				case 'Form':
					try {
						const forms = await API().get(`Organizations/${orgId}/events/${eventId}/forms`);
						modelOptions = (forms.data.forms || []).map((f) => ({ label: f.name, value: f._id }));
					} catch (err) {
						console.log('Error fetching forms', err);
					}
					break;
				case 'Feed':
					modelOptions = (this.props.feeds || []).map((f) => ({ label: f.feedName, value: f._id }));
					break;
				case 'Attendee':
					modelOptions = (this.props.attendees || []).map((a) => ({
						label: `${a.firstName} ${a.lastName}`,
						value: a._id
					}));
					break;
				default:
					break;
			}
		}

		this.setState({
			selectedValue: e,
			referenceModel: referenceModel,
			modelOptions: modelOptions,
			referenceId: '',
			error: '',
			requiredFields: { selectedValue: false, referenceId: false }
		});
	};

	handleReferenceChosen = (e) => {
		this.setState({
			referenceId: e.value,
			error: '',
			requiredFields: { ...this.state.requiredFields, referenceId: false }
		});
	};

	submitInteractionPoints = () => {
		const { availablePoints, selectedValue } = this.state;
		const selectedPoint = availablePoints.length > 0 && availablePoints.find((p) => p._id == selectedValue.value);
		const referenceId = this.state.referenceId;
		const requiredFields = { ...this.state.requiredFields };
		let valid = true;
		let error = '';

		// Use `p.id` (the definition ID) to find existing similar points — NOT `p._id` (the record ID)
		const existingSimilarPoints = selectedPoint
			? (this.props.interactionPoints || []).filter((p) => p.id == selectedPoint._id)
			: [];

		if (!selectedPoint) {
			requiredFields.selectedValue = true;
			valid = false;
			error = 'Point is required';
		} else {
			requiredFields.selectedValue = false;

			if (selectedPoint.oncePerReference && !referenceId) {
				requiredFields.referenceId = true;
				valid = false;
				error = 'Reference is required';
			} else if (selectedPoint.oncePerReference && existingSimilarPoints.find((p) => p.referenceId == referenceId)) {
				requiredFields.referenceId = true;
				valid = false;
				error = 'Point already exists for this reference';
			} else if (selectedPoint.maxPointsAllowed > 0 && existingSimilarPoints.length >= selectedPoint.maxPointsAllowed) {
				// 0 means unlimited — only block when a positive limit is exceeded
				valid = false;
				error = 'Max points allowed reached';
			} else {
				requiredFields.referenceId = false;
			}
		}

		if (valid) {
			this.setState({ submitting: true, requiredFields: requiredFields, error: '' });
			this.props.add(selectedPoint, referenceId, (success, errorMessage) => {
				if (!success) {
					this.setState({
						submitting: false,
						error: errorMessage || 'Failed to add points. Please try again.'
					});
				}
			});
		} else {
			this.setState({ invalid: true, requiredFields: requiredFields, error: error });
		}
	};

	render() {
		const { isOpen, toggle } = this.props;
		const {
			availablePointOptions,
			availablePoints,
			submitting,
			selectedValue,
			referenceId,
			referenceModel,
			modelOptions,
			requiredFields,
			error
		} = this.state;

		const selectedPoint = availablePoints.length > 0 && availablePoints.find((p) => p._id == selectedValue.value);
		const needsReference = selectedPoint && selectedPoint.oncePerReference;

		// Compute submit eligibility directly from state — no flag needed
		const canSubmit = !!selectedPoint && (!selectedPoint.oncePerReference || !!referenceId);

		return (
			<div>
				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={"Add Interaction Points"}
					bodyHeaderText={`Points will be added to attendee total`}
					bodyContent={() => {
						return (
							<div>
								<SelectField
									classes={`w-100`}
									label="Available Point Options"
									value={selectedValue}
									name="availablePointOptions"
									options={availablePointOptions}
									required={true}
									errorTrigger={requiredFields.selectedValue}
									onChange={this.handlePointsChosen}
								/>

								{needsReference && (
									<div>
										{referenceModel === 'Session' || referenceModel === 'Survey' || referenceModel === 'Form' || referenceModel === 'Feed' || referenceModel === 'Attendee' ? (
											<SelectField
												classes={`w-100`}
												label={referenceModel}
												options={modelOptions}
												required={true}
												errorTrigger={requiredFields.referenceId}
												errorMessage={error}
												value={modelOptions.find((o) => o.value == referenceId) || null}
												name="referenceId"
												onChange={this.handleReferenceChosen}
											/>
										) : (
											<InputField
												label="Reference ID"
												onChange={(e) => this.setState({ referenceId: e.target.value, error: '' })}
												value={referenceId}
												errorTrigger={requiredFields.referenceId}
												errorMessage={error}
												required={true}
											/>
										)}
									</div>
								)}

								{error && !requiredFields.referenceId && (
									<p className="error-message mt-10" style={{ color: 'var(--color-red, #e53e3e)', fontSize: 13 }}>
										{error}
									</p>
								)}
							</div>
						)
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Submit' : 'Adding Point...'}
					cancelButtonLabel={'Cancel'}
					actionButton={() => this.submitInteractionPoints()}
					submitting={submitting}
					actionButtonDisabled={submitting || !canSubmit}
				></FieldModal>
			</div>
		);
	}
}

export default AddPointsModal;
